import React from "react";
import { useNavigate } from "react-router-dom";
import "./CategoriesDisplay.css";

function CategoriesDisplay({ title }) {
  const navigate = useNavigate();

  const handleViewMoreClick = () => {
    navigate("/courses");
  };

  return (
    <div className="categories-container">
      <span className="categories-title">{title}</span>
      <span className="view-more" onClick={handleViewMoreClick}>View More</span>
    </div>
  );
}

export default CategoriesDisplay;
